module.exports = __webpack_public_path__ + "img/04.c5130b5a.jpg";